var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-tree", {
    ref: "selectTree",
    attrs: {
      width: _vm.width,
      placeholder: "请选择所属机构",
      options: _vm.options,
      props: _vm.defaultProps,
      "show-checkbox": _vm.showCheckbox,
      "check-on-click-node": _vm.showCheckbox,
      "default-expanded-keys": _vm.defaultExpandedKeys,
      disabled: _vm.disabled,
      singleChoose: _vm.singleChoose,
      checkStrictly: _vm.checkStrictly,
    },
    model: {
      value: _vm.tempValue,
      callback: function ($$v) {
        _vm.tempValue = $$v
      },
      expression: "tempValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }